// do not manually modify this auto-generated file!!

export const allLocales = [
  {
    "lang": "ar",
    "namespace": "designSystem",
    "file": "common",
    "translations": {
      "dataTable": {
        "noSearchResultsFound": "No search results found."
      }
    }
  },
  {
    "lang": "en",
    "namespace": "designSystem",
    "file": "common",
    "translations": {
      "dataTable": {
        "noSearchResultsFound": "No search results found."
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "designSystem",
    "file": "common",
    "translations": {
      "welcome": "स्वागत है"
    }
  },
  {
    "lang": "ru",
    "namespace": "designSystem",
    "file": "common",
    "translations": {
      "welcome": "Добро пожаловать"
    }
  },
  {
    "lang": "zh",
    "namespace": "designSystem",
    "file": "common",
    "translations": {
      "welcome": "欢迎"
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "common",
    "translations": {
      "cancel": "إلغاء",
      "save": "حفظ",
      "loading": "جاري التحميل...",
      "delete": "حذف المنظمة",
      "submit": "إرسال",
      "search": "بحث",
      "genericError": "Something went wrong. Try again",
      "navMenu": {
        "users": "المستخدمين",
        "teams": "الفرق",
        "projects": "المشاريع",
        "orgs": "المنظمات",
        "logs": "السجلات",
        "userPreferences": "تفضيلات المستخدم",
        "logout": "تسجيل الخروج",
        "orgPrefix": "لـ",
        "superAdmin": "المشرف العام"
      },
      "products": {
        "analytics": "التحليلات",
        "manager": "المدير",
        "agentAssist": "مركز الاتصال",
        "youDontHaveAccess": "ليس لديك حق الوصول إلى هذه الأداة، يرجى الاتصال بمسؤول",
        "proStudio": "ستوديو برو",
        "analyticsDescription": "إفتح الرؤى وتحسين العمليات.",
        "managerDescription": "تنظيم فريقك والمشاريع بكفاءة.",
        "agentAssistDescription": "منصة التواصل العميلي الذكية.",
        "proStudioDescription": "إنشاء عمليات ذكية باستخدام الذكاء الاصطناعي."
      },
      "homepage": {
        "header": {
          "tools": "أدوات"
        },
        "projects": {
          "createProject": "إنشاء مشروع",
          "yourProjects": "مشاريعك",
          "project": "مشروع",
          "tools": "أدوات",
          "lastUpdated": "آخر تحديث",
          "toGetStartedCreateProject": "للبدء، أنشئ مشروعك الأول.",
          "nothingToShowHere": "لا يوجد شيء لعرضه هنا...",
          "YouDontHaveAccessToTheToolsInThisProject": "ليس لديك حق الوصول إلى الأدوات في هذا المشروع. يرجى الاتصال بمسؤول.",
          "YouDontHaveAccessToThisTool": "ليس لديك حق الوصول إلى هذه الأداة.",
          "manageProject": "إدارة المشروع"
        },
        "contacts": {
          "needHelp": "بحاجة الى مساعدة؟",
          "yourBrowserDoesNotSupportVideoTag": "المتصفح الخاص بك لا يدعم علامة الفيديو.",
          "startChat": "ابدأ الدردشة",
          "learnMore": "تعلم المزيد",
          "visitOurSite": "قم بزيارة موقعنا",
          "seeOurBlog": "انظر الى مدونتنا",
          "blog": "مدونة",
          "haveQuestions": "هل لديك أسئلة؟",
          "helpCenter": "مركز المساعدة"
        },
        "noToolAccessMessage": "ليس لديك حق الوصول إلى أي مشاريع {{appName}} في هذه المنظمة. تم إعادة توجيهك إلى الرئيسية."
      },
      "firstName": "الاسم الأول",
      "lastName": "الاسم الأخير",
      "emailAddress": "البريد الإلكتروني",
      "permissionAndAccessTable": {
        "teamEmptyState": "لم يتم العثور على أي فرق.",
        "addProject": "إضافة مشروع",
        "orgTitle": "منظمة",
        "projectTitle": "مشروع",
        "roleTitle": "دور",
        "toolTitle": "أداة",
        "orgParent": "الوالد",
        "roles": {
          "viewOnly": "للعرض فقط"
        },
        "projectsEmptyState": "لا يوجد لدى هذه المنظمة أي مشاريع. أنشئ واحدًا للبدء.",
        "projectsEmptyStateForViewUser": "لا توجد مشاريع لهذه المنظمة. تواصل مع أحد المشرفين للبدء.",
        "noProjectsAssigned": "لم يتم تعيين أي مشاريع",
        "addTeam": "إضافة فريق",
        "noPermissionsAssigned": "لا يوجد وصول - تعيين دور",
        "managerRoleTooltip": "يؤدي تعيين دور المدير لهذه المنظمة إلى تعيينه لجميع المنظمات الفرعية الحالية والمستقبلية.",
        "teamRoleTooltip": "يرث المستخدمون في الفريق جميع الأدوار الخاصة بهذا الفريق."
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "logs",
    "translations": {
      "title": "السجلات",
      "table": {
        "column1": "الإجراء",
        "column2": "المستخدم",
        "column3": "الوقت"
      },
      "empty": "لا توجد بيانات",
      "showing": "عرض",
      "of": "من",
      "page": "الصفحة"
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "organizations",
    "translations": {
      "childOrgsList": {
        "childOrgs": "المنظمات الفرعية ({{count}})",
        "createOrg": "إنشاء منظمة فرعية",
        "editOrg": "تحرير المنظمة",
        "viewOrg": "عرض المنظمة",
        "created": "تم الإنشاء {{date}}",
        "table": {
          "name": "الاسم",
          "users": "المستخدمين",
          "teams": "الفرق",
          "projects": "المشاريع",
          "childOrgs": "المنظمات الفرعية",
          "updated": "آخر تحديث"
        },
        "createToGetStarted": "أنشئ منظمة للبدء."
      },
      "orgDetails": {
        "title": "تفاصيل المنظمة"
      },
      "createOrg": {
        "title": "إنشاء منظمة فرعية",
        "cancel": "إلغاء",
        "create": "إنشاء منظمة فرعية",
        "creating": "إنشاء منظمة للأطفال...",
        "name": "الاسم*",
        "loginMethods": "طرق الدخول",
        "authProvider": "مقدم المصادقة*",
        "icon": "الأيقونة",
        "accountManager": "مدير الحساب",
        "clientId": "معرف العميل",
        "clientIdSaml": "عنوان URL لتسجيل الدخول مرة واحدة",
        "clientSecret": "سر العميل",
        "clientSecretSaml": "شهادة X.509",
        "issuerURL": "معرف URI الخاص بالجهة المصدرة",
        "issuerURLSaml": "معرف كيان مزود الخدمة",
        "issuerURLHelpText": "المعرف الفريد لمزود الخدمة (SP) الخاص بك.",
        "usernameAttribute": "اسم السمة اسم المستخدم",
        "emailAttribute": "اسم سمة البريد الإلكتروني",
        "redirectURL": "رابط التحويل",
        "entityIssuer": "معرف كيان مزود الهوية (الجهة المصدرة)",
        "entityIssuerHelpText": "المعرف الفريد لموفر هوية المستخدم (IdP). هذا الحقل اختياري، ويُرجى ملؤه فقط إذا طلبه موفر هويتك.",
        "redirectURLHelpText": "استخدم هذا الرابط وأضفه إلى قائمة الروابط المسموحة بها في إعدادات التطبيق الخاص بك في مقدم المصادقة. يتطلب هذا أن يتم توجيه المستخدمين بنجاح إلى المنظمة بعد تسجيل الدخول.",
        "placeholders": {
          "name": "الاسم",
          "authProvider": "اختر مقدم المصادقة",
          "accountManager": "اختر مدير الحساب",
          "dragPicture": "اسحب صورة هنا",
          "selectFile": "حدد ملفًا",
          "emailDomain": "@domain.com"
        },
        "nameIDPolicyFormat": "تنسيق سياسة معرف الاسم",
        "fieldIsRequired": "{{field}} مطلوب.",
        "nameIDPolicyFormatHelpText": "صيغة مُعرِّف اسم المستخدم. هذا الحقل اختياري، ويُرجى ملؤه فقط إذا طلبه مُزوِّد هويتك."
      },
      "editOrg": {
        "cancel": "إلغاء",
        "back": "خلف",
        "save": "حفظ",
        "saving": "توفير...",
        "delete": "حذف المنظمة",
        "deleteModal": {
          "cancel": "إلغاء",
          "removeOrg": "حذف المنظمة",
          "areYouSure": "هل أنت متأكد؟",
          "description": "حذف هذه المنظمة سيؤدي إلى حذف {{usersCount}} من المستخدمين و{{projectsCount}} من المشاريع. لا يمكن التراجع عن ذلك."
        }
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "preferences",
    "translations": {
      "title": "حسابي",
      "general": {
        "details": "التفاصيل",
        "name": "الاسم*",
        "email_address": "عنوان البريد الإلكتروني*",
        "job_title": "المسمى الوظيفي",
        "profile_picture": "الصورة الشخصية",
        "cookie_policy": "سياسة ملفات تعريف الارتباط",
        "other_policies": "السياسات الأخرى",
        "reset_password": "إعادة تعيين كلمة المرور",
        "reset_password_help": "Googleلإعادة تعيين كلمة المرور، قم بزيارة حسابك على",
        "language_timezone": "اللغة والمنطقة الزمنية",
        "default_language": "اللغة الافتراضية",
        "default_timezone": "المنطقة الزمنية",
        "add_job_title": "أضف المسمى الوظيفي",
        "add_name": "أضف الاسم",
        "add_surname": "أضف اللقب",
        "add_email_address": "أضف عنوان البريد الإلكتروني",
        "cookie_policy_label_prefix": "الموافقة على",
        "cookie_policy_label_suffix": "لمساعدتنا في تحسين تجربتك",
        "privacy_policy": "سياسة الخصوصية",
        "terms_conditions": "الشروط والأحكام",
        "dsar_form": "نموذج DSAR",
        "upload_profile_picture_on_google": "Googleللاستبدال أو الإزالة، قم بزيارة حسابك على",
        "upload_a_file_here": "ارفع ملفًا هنا",
        "select_a_language": "اختر لغة",
        "select_a_time_zone": "اختر منطقة زمنية",
        "language_select_hint": "لا ينطبق على مركز الاتصال والتحليلات"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "projects",
    "translations": {
      "projectsList": {
        "projects": "المشاريع",
        "createProject": "إنشاء مشروع",
        "table": {
          "name": "الاسم",
          "users": "المستخدمين",
          "tools": "الأدوات",
          "updated": "آخر تحديث"
        }
      },
      "sidebar": {
        "backToProjects": "الرجوعالى المشاريع",
        "general": "عام",
        "environments": "البيئات",
        "environmentName": "{{environmentName}}",
        "projectDetails": "تفاصيل المشروع",
        "appletDetails": "تفاصيل التطبيق"
      },
      "environments": {
        "development": "التطوير",
        "testing": "الاختبار",
        "production": "الإنتاج",
        "staging": "التدريج"
      },
      "projectDetails": {
        "deleteModal": {
          "areYouSure": "هل أنت متأكد؟",
          "youWillLose": "ستفقد نهائيًا:",
          "accessToProjectTools": "الوصول إلى أدوات المشروع",
          "dataInsideProjectTools": "البيانات داخل أدوات المشروع",
          "rolesAssignedForProjectTools": "الأدوار المعينة لأدوات المشروع",
          "removeProject": "حذف المشروع",
          "cancel": "إلغاء"
        },
        "createAppletModal": {
          "step1": {
            "title": "إنشاء تطبيق",
            "subTitle": "تطبيق Pypestream هو بيئة التشغيل لوظائف منصة Pypestream على موقع معين. يستدعي كود App Loader منصة Pypestream ويسترجع وينفذ أي تعليمات برمجية إضافية على الصفحة بناءً على شروط معينة. يتضمن ذلك كود تتبع التحليلات وكود الدردشة وعناصر من محرك الأتمتة.",
            "name": "اسم التطبيق",
            "description": "الوصف (اختياري)",
            "required": "هذا الحقل مطلوب"
          },
          "step2": {
            "title": "اختر قالب التطبيق للبدء",
            "subTitle": "تساعدك قوالب التطبيقات على بناء التطبيقات مع إعدادات أقل",
            "required": "يرجى اختيار تطبيق واحد",
            "applets": {
              "analytics": "تحليلات",
              "pype": "Pype",
              "custom": "مخصص"
            }
          },
          "step3": {
            "title": "نجاح!",
            "subTitle": "تم إنشاء التطبيق الجديد...",
            "button": "تم"
          },
          "nextStep": "التالي",
          "backStep": "رجوع"
        },
        "deleteAppletModal": {
          "areYouSure": "هل أنت متأكد؟",
          "youWillLose": "ستفقد نهائيًا:",
          "accessToApplet": "الوصول إلى التطبيق",
          "removeApplet": "حذف التطبيق",
          "cancel": "إلغاء"
        },
        "updateAppletInstanceStatusModal": {
          "title": "هل أنت متأكد؟",
          "description": "وصف تبديل الحالة",
          "confirmButton": "تحديث التطبيق",
          "cancelButton": "إلغاء"
        },
        "deleteToolModal": {
          "title": "هل أنت متأكد؟",
          "subTitle": "ستفقد بشكل دائم:",
          "line1": "الوصول إلى هذه الأداة",
          "line2": "الأدوار المعينة",
          "line3": "البيانات داخل الأداة",
          "deleteButton": "حذف الأداة"
        },
        "environmentURLModal": {
          "title": "تعيين عناوين URL لـ {{environmentName}}",
          "subTitle": "تنظم المشاريع العمل حول ممتلكات رقمية مثل المواقع الإلكترونية. يجب ربط كل شيء في المشروع بنطاق ويمكن تغيير الإعدادات في إعدادات المشروع.",
          "addURLButton": "إضافة عنوان URL لـ {{environmentName}}"
        },
        "cancel": "إلغاء",
        "save": "حفظ",
        "delete": "حذف المشروع",
        "created": "تم الإنشاء {{date}}",
        "generalTab": {
          "title": "عام",
          "details": {
            "detailsCaption": "التفاصيل",
            "name": "الاسم",
            "description": "الوصف",
            "projectIcon": "أيقونة المشروع",
            "placeholders": {
              "addName": "أضف الاسم",
              "addDescription": "أضف الوصف",
              "dragPhoto": "قم بسحب الصورة إلى هنا",
              "selectFile": "حدد ملفًا"
            }
          },
          "tools": {
            "toolsCaption": "الأدوات",
            "configureToolsYouNeed": "قم بإعداد الأدوات التي تحتاجها لمشروعك",
            "selectOneOrMoreProducts": "يرجى اختيار أداة أو أكثر"
          },
          "languageAndTimezone": {
            "languageCaption": "الإعدادات اللغوية",
            "defaultLanguage": "اللغة الافتراضية",
            "defaultTimezone": "المنطقة الزمنية",
            "placeholders": {
              "selectLanguage": "اختر اللغة",
              "selectTimezone": "اختر المنطقة الزمنية"
            },
            "helpText": {
              "locale": "ينطبق فقط على مركز الاتصال",
              "timezone": "ينطبق فقط على للتحليلات"
            }
          }
        },
        "environmentsTab": {
          "title": "نظرة عامة على النشر",
          "appletsSection": {
            "title": "تطبيقات الويب",
            "addButton": "إضافة تطبيق",
            "description": "تطبيق Pypestream هو بيئة التشغيل لوظائف منصة Pypestream على موقع معين.",
            "status": "سحابة",
            "trigger": {
              "title": "مشغل",
              "label": "لم يتم تعيين مشغل"
            },
            "actions": {
              "title": "إجراءات",
              "label": "لم يتم تعيين إجراءات"
            }
          },
          "platformSection": {
            "title": "تكامل المنصة",
            "addButton": "إضافة تكاملات"
          },
          "summarySection": {
            "developmentUrls": "عناوين URL الخاصة بـ {{environmentName}}",
            "appInterfaces": "واجهات التطبيقات",
            "variables": "المتغيرات"
          },
          "caption": "البيئات",
          "environmentName": "{{environmentName}}",
          "description": "تنظم المشاريع العمل حول ممتلكات عبر الإنترنت مثل الموقع الإلكتروني. يجب ربط كل شيء في المشروع بنطاق، وبشكل اختياري، نطاقاته الفرعية.",
          "addEnvironmentUrl": "إضافة عنوان URL لـ {{environmentName}}",
          "gqlPlaygroundsButton": "ملعب GQL للتطبيقات"
        }
      },
      "createProject": {
        "step1": {
          "title": "إنشاء مشروع",
          "name": "اسم المشروع",
          "description": "الوصف (اختياري)",
          "icon": "أيقونة المشروع (اختياري)"
        },
        "step2": {
          "title": "عناوين URL للبيئات",
          "field1": "الإنتاج",
          "field1Button": "إضافة عنوان URL للإنتاج",
          "field2": "التدريج",
          "field2Button": "إضافة عنوان URL للتدريج",
          "field3": "التطوير",
          "field3Button": "إضافة عنوان URL للتطوير",
          "errors": {
            "default": "يجب أن يكون هذا الحقل عنوان URL صالحًا.",
            "invalidDomain": "النطاق الأعلى غير صالح",
            "invalidURL": "عنوان URL غير صالح",
            "intersection": "عنوان URL هذا ({{intersection}}) مستخدم في مشروع آخر"
          }
        },
        "step3": {
          "title": "اختر الأدوات للدمج",
          "required": "يرجى اختيار أداة واحدة أو أكثر"
        },
        "step4": {
          "title": "التعريب"
        },
        "step5": {
          "title": "نجاح!",
          "subTitle": "تم إنشاء المشروع الجديد...",
          "button": "تم"
        },
        "required": "هذا الحقل مطلوب",
        "nextStep": "التالي",
        "backStep": "السابق"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "super-admin",
    "translations": {
      "title": "المشرف العام",
      "permission": "ليس لديك إذن لعرض هذه الصفحة",
      "section1": {
        "title": "هذا الزر لالتقاط لقطة من قاعدة البيانات",
        "button": "التقاط لقطة"
      },
      "section2": {
        "title": "رابط إلى صفحة إعدادات التحليلات",
        "button": "التحليلات"
      },
      "section3": {
        "title": "رابط إلى صفحة المشرف العام لمركز الاتصال",
        "button": "مركز الاتصال"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "teams",
    "translations": {
      "teamsList": {
        "teams": "الفرق",
        "createTeam": "إنشاء فريق",
        "table": {
          "name": "الاسم",
          "users": "المستخدمين",
          "updated": "آخر تحديث"
        },
        "createToGetStarted": "أنشئ فريقًا للبدء."
      },
      "teamDetails": {
        "createTeam": "إنشاء فريق",
        "deleteTeam": "حذف الفريق",
        "teamInfo": {
          "name": "اسم",
          "description": "وصف",
          "contactCenterAccess": "يؤدي منح فريق حق الوصول إلى نسخة مركز الاتصال إلى إنشاء فريق مرتبط بها. لا يمكن إدارة الفرق إلا هنا، وليس في مركز الاتصال."
        },
        "teamUsers": {
          "teamMembers": "أعضاء الفريق",
          "teamMembersSubTitle": "يرث أعضاء الفريق جميع الأدوار المخصصة للفريق.",
          "teamMembersOtherOrgs": "أعضاء الفريق في المنظمات الأخرى",
          "teamMembersOtherOrgsSubTitle": "لا يمكن إدارة أعضاء الفريق في منظمات أخرى من هذه الشاشة. لإزالتهم من هذا الفريق، انتقل إلى إعدادات المستخدم الخاصة بهم.",
          "user": "مستخدم",
          "lastActive": "آخر نشاط",
          "addUsers": "إضافة المستخدمين",
          "noUsers": "لا يوجد مستخدمين في هذه المنظمة",
          "noUsersInTeam": "لا يوجد مستخدمين في هذا الفريق."
        },
        "deleteTeamModal": {
          "mainTitle": "حذف الفريق {{teamName}}؟",
          "subTitle": "سيؤدي حذف {{teamName}} إلى:",
          "line1": "إزالة الأدوار الموروثة من جميع المستخدمين في هذا الفريق",
          "line2": "حذف أي فرق مرتبطة في حالات مركز الاتصال المرتبطة",
          "cancel": "يلغي",
          "delete": "يمسح",
          "deleting": "جاري الحذف..."
        },
        "snackbar": {
          "createTeamText": "عندما تكون مستعدًا، قم بإنشاء الفريق",
          "updateTeamText": "هناك تغييرات غير محفوظة",
          "cancel": "يلغي",
          "create": "إنشاء فريق",
          "creating": "إنشاء فريق...",
          "update": "حفظ التغييرات",
          "updating": "حفظ التغييرات..."
        },
        "permissionAndAccessTitle": "الأدوار"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "manager",
    "file": "users",
    "translations": {
      "usersList": {
        "users": "المستخدمين",
        "createUser": "إنشاء مستخدم",
        "bulkInviteUsers": "دعوة جماعية",
        "bulkInviting": "دعوة...",
        "table": {
          "name": "الاسم",
          "email": "البريد الإلكتروني",
          "lastActive": "آخر نشاط",
          "invited": "تم الدعوة"
        },
        "createToGetStarted": "أنشئ مستخدمًا للبدء."
      },
      "userDetails": {
        "title": "تفاصيل المستخدم",
        "permissionAndAccessTitle": "الأدوار",
        "deleteUserConfirmationModal": {
          "description": "سيتم إزالة جميع صلاحياتهم. لا يمكن التراجع عن هذا الإجراء.",
          "title": "حذف {{userName}}؟"
        },
        "agentConversationLimit": "حد محادثة الوكيل",
        "agentConversationLimitTooltip": "الحد الأقصى لعدد المحادثات التي يمكن تعيينها لوكيل في وقت واحد.",
        "smartOrgMenu": "القائمة التنظيمية الذكية",
        "smartOrgMenuTooltip": "يعرض فقط المنظمات التي يمكنك الوصول إلى أداة واحدة على الأقل منها أو التي تكون فيها عضوًا في فريق. تبقى المنظمات الرئيسية مرئية إذا كانت تحتوي على منظمات فرعية مرئية. تبقى منظمتك الرئيسية مرئية."
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "common",
    "translations": {
      "cancel": "Cancel",
      "save": "Save Changes",
      "loading": "Loading...",
      "delete": "Delete",
      "submit": "Submit",
      "search": "Search",
      "genericError": "Something went wrong. Try again",
      "navMenu": {
        "users": "Users",
        "teams": "Teams",
        "projects": "Projects",
        "orgs": "Orgs",
        "logs": "Logs",
        "userPreferences": "My Account",
        "logout": "Logout",
        "orgPrefix": "for",
        "superAdmin": "Super Admin"
      },
      "products": {
        "analytics": "Analytics",
        "manager": "Manager",
        "agentAssist": "Contact Center",
        "youDontHaveAccess": "You don’t have access to this tool, please contact an admin",
        "proStudio": "Pro Studio",
        "analyticsDescription": "Unlock insights and optimize workflows.",
        "managerDescription": "Organize your team and projects efficiently.",
        "agentAssistDescription": "AI powered customer engagement platform.",
        "proStudioDescription": "Build AI powered workflows."
      },
      "homepage": {
        "header": {
          "tools": "Tools"
        },
        "projects": {
          "createProject": "Create Project",
          "yourProjects": "Your Projects",
          "project": "Project",
          "tools": "Tools",
          "lastUpdated": "Last updated",
          "toGetStartedCreateProject": "To get started, create your first project.",
          "nothingToShowHere": "Nothing to show here...",
          "YouDontHaveAccessToTheToolsInThisProject": "You do not have access to the tools in this project. Contact an admin.",
          "YouDontHaveAccessToThisTool": "You do not have access to this tool.",
          "manageProject": "Manage Project"
        },
        "contacts": {
          "needHelp": "Need Help?",
          "yourBrowserDoesNotSupportVideoTag": "Your browser does not support the video tag.",
          "startChat": "Start Chat",
          "learnMore": "Learn More...",
          "visitOurSite": "Visit our site",
          "seeOurBlog": "See our blog",
          "blog": "Blog",
          "haveQuestions": "Have questions?",
          "helpCenter": "Help Center"
        },
        "noToolAccessMessage": "You don't have access to any {{appName}} projects in this Organization. You've been brought to Home."
      },
      "firstName": "First Name",
      "lastName": "Last Name",
      "emailAddress": "Email Address",
      "permissionAndAccessTable": {
        "teamEmptyState": "No teams found.",
        "addProject": "Add Project",
        "orgTitle": "Org",
        "projectTitle": "Project",
        "roleTitle": "Role",
        "toolTitle": "Tool",
        "orgParent": "Parent",
        "roles": {
          "viewOnly": "View Only"
        },
        "projectsEmptyState": "This Org has no Projects. Create one to get started.",
        "projectsEmptyStateForViewUser": "This Org has no Projects. Contact an admin to get started.",
        "noProjectsAssigned": "No projects assigned",
        "addTeam": "Add Team",
        "noPermissionsAssigned": "No access — assign a role",
        "managerRoleTooltip": "Assigning a Manager role for this Org assigns it for all current and future Child Orgs.",
        "teamRoleTooltip": "Users on a Team inherit all roles of that Team."
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "logs",
    "translations": {
      "title": "Logs",
      "table": {
        "column1": "Action",
        "column2": "User",
        "column3": "When"
      },
      "empty": "No data",
      "showing": "Showing",
      "of": "of",
      "page": "page"
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "organizations",
    "translations": {
      "childOrgsList": {
        "childOrgs": "Child Orgs ({{count}})",
        "createOrg": "Create Child Org",
        "editOrg": "Edit Org",
        "viewOrg": "View Org",
        "created": "Created {{date}}",
        "table": {
          "name": "Name",
          "users": "Users",
          "teams": "Teams",
          "projects": "Projects",
          "childOrgs": "Child Orgs",
          "updated": "Last updated"
        },
        "createToGetStarted": "Create an org to get started."
      },
      "orgDetails": {
        "title": "Org Details"
      },
      "createOrg": {
        "title": "Create Child Org",
        "cancel": "Cancel",
        "create": "Create Org",
        "creating": "Creating Org...",
        "name": "Name*",
        "loginMethods": "Login Methods",
        "icon": "Icon",
        "accountManager": "Account Manager",
        "clientId": "Client ID",
        "clientIdSaml": "Single Sign-On URL",
        "clientSecret": "Client Secret",
        "clientSecretSaml": "X.509 Certificate",
        "issuerURL": "Issuer URI",
        "issuerURLSaml": "Service Provider Entity ID",
        "issuerURLHelpText": "The unique identifier for your Service Provider (SP).",
        "usernameAttribute": "Username Attribute Name",
        "emailAttribute": "Email Attribute Name",
        "redirectURL": "Redirect URI",
        "entityIssuer": "Identity Provider Entity ID (Issuer)",
        "entityIssuerHelpText": "The unique identifier for the user's Identity Provider (IdP). This field is optional and should only be filled in if your identity provider requires it.",
        "redirectURLHelpText": "Copy this URI and add it to the list of allowed redirect URIs in your OpenID Connect provider’s application settings. This is required for users to be successfully redirected back after logging in.",
        "placeholders": {
          "name": "Name",
          "loginMethod": "Select login method",
          "accountManager": "Select account manager",
          "dragPicture": "Drag a photo here",
          "selectFile": "Select a file",
          "emailDomain": "@domain.com"
        },
        "nameIDPolicyFormat": "Name ID Policy Format",
        "fieldIsRequired": "{{field}} is required.",
        "nameIDPolicyFormatHelpText": "The format of the user’s NameID. This field is optional and should only be filled in if your identity provider requires it."
      },
      "editOrg": {
        "cancel": "Cancel",
        "back": "Back",
        "save": "Save Changes",
        "saving": "Saving...",
        "delete": "Delete Org",
        "deleteModal": {
          "cancel": "Cancel",
          "removeOrg": "Delete Org",
          "areYouSure": "Are you sure?",
          "description": "Deleting this Org will delete all users, Projects, and Child Orgs associated with it, including their users and projects. This cannot be undone."
        }
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "preferences",
    "translations": {
      "title": "My Account",
      "general": {
        "details": "Details",
        "name": "Name*",
        "email_address": "Email address*",
        "job_title": "Job Title",
        "profile_picture": "Profile Picture",
        "cookie_policy": "Cookie Policy",
        "other_policies": "Other Policies",
        "reset_password": "Reset Password",
        "reset_password_help": "To reset your password, visit your Google account",
        "language_timezone": "Language & Timezone",
        "default_language": "Default language",
        "default_timezone": "Timezone",
        "add_job_title": "Add Job Title",
        "add_name": "Add Name",
        "add_surname": "Add Surname",
        "add_email_address": "Add Email address",
        "cookie_policy_label_prefix": "Opt in to the",
        "cookie_policy_label_suffix": "to help us improve your experience",
        "privacy_policy": "Privacy Policy",
        "terms_conditions": "Terms & Conditions",
        "dsar_form": "DSAR Form",
        "upload_profile_picture_on_google": "To replace or remove, visit your Google account",
        "upload_a_file_here": "Upload a file here",
        "select_a_language": "Select a language",
        "select_a_time_zone": "Select a time zone",
        "language_select_hint": "Does not apply to Contact Center and Analytics"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "projects",
    "translations": {
      "projectsList": {
        "projects": "Projects",
        "createProject": "Create Project",
        "table": {
          "name": "Name",
          "users": "Users",
          "tools": "Tools",
          "updated": "Last updated"
        }
      },
      "sidebar": {
        "backToProjects": "All Projects",
        "general": "General",
        "environments": "Environments",
        "environmentName": "{{environmentName}}",
        "projectDetails": "Project Details",
        "appletDetails": "Applet Details"
      },
      "environments": {
        "development": "Development",
        "testing": "Testing",
        "production": "Production",
        "staging": "Staging"
      },
      "projectDetails": {
        "deleteModal": {
          "areYouSure": "Are you sure?",
          "youWillLose": "You'll permanently lose:",
          "accessToProjectTools": "access to this Project's tool instances",
          "dataInsideProjectTools": "all data inside this Project's tool instances",
          "rolesAssignedForProjectTools": "all roles assigned for this Project's tool instances",
          "removeProject": "Delete Project",
          "cancel": "Cancel"
        },
        "createAppletModal": {
          "step1": {
            "title": "Create an Applet",
            "subTitle": "The Pypestream Applet is the runtime environment for Pypestream platform functionality on a given website. The App Loader code snippet calls the Pypestream platform and retrieves and executes any additional code needed on the page assuming certain conditions are met. This includes Analytics tracking code, chat widget code, and Elements from the automation engine.",
            "name": "Applet Name",
            "description": "Description (optional)",
            "required": "This is a required field"
          },
          "step2": {
            "title": "Select applet template to start with",
            "subTitle": "Applets templates help you to build applets with less configurations",
            "required": "Please select one applet",
            "applets": {
              "analytics": "Analytics",
              "pype": "Pype",
              "custom": "Custom"
            }
          },
          "step3": {
            "title": "Success!",
            "subTitle": "New applet has been created...",
            "button": "Done"
          },
          "nextStep": "Next",
          "backStep": "Back"
        },
        "deleteAppletModal": {
          "areYouSure": "Are you sure?",
          "youWillLose": "You'll permanently lose:",
          "accessToApplet": "access to this Applet instance",
          "removeApplet": "Delete Applet",
          "cancel": "Cancel"
        },
        "updateAppletInstanceStatusModal": {
          "title": "Are you sure?",
          "description": "Toggle status description",
          "confirmButton": "Update Applet",
          "cancelButton": "Cancel"
        },
        "deleteToolModal": {
          "title": "Are you sure?",
          "subTitle": "You'll permanently lose your:",
          "line1": "access to this tool instance",
          "line2": "assigned roles",
          "line3": "data inside the tool",
          "deleteButton": "Delete Tool"
        },
        "environmentURLModal": {
          "title": "Set {{environmentName}} URLs",
          "subTitle": "Projects organize work around an online property like a website. Everything in the project must be tied to a domain and, optionally, its subdomains. You can make changes in project settings.",
          "addURLButton": "Add {{environmentName}} URL"
        },
        "cancel": "Cancel",
        "save": "Save",
        "delete": "Delete Project",
        "created": "Created {{date}}",
        "generalTab": {
          "title": "General",
          "details": {
            "detailsCaption": "Details",
            "name": "Name*",
            "description": "Description",
            "projectIcon": "Project Icon",
            "placeholders": {
              "addName": "Add Name",
              "addDescription": "Add description",
              "dragPhoto": "Drag a photo here",
              "selectFile": "Select a file"
            }
          },
          "tools": {
            "toolsCaption": "Tools",
            "configureToolsYouNeed": "Configure the tools you need for your project",
            "selectOneOrMoreProducts": "Please select one or more tools"
          },
          "languageAndTimezone": {
            "languageCaption": "Localization",
            "defaultLanguage": "Default language",
            "defaultTimezone": "Timezone",
            "placeholders": {
              "selectLanguage": "Select language",
              "selectTimezone": "Select timezone"
            },
            "helpText": {
              "locale": "Applies only to Contact Center",
              "timezone": "Applies only to Analytics"
            }
          }
        },
        "environmentsTab": {
          "title": "Deployment Overview",
          "appletsSection": {
            "title": "Web Applets",
            "addButton": "Add Applet",
            "description": "The Pypestream Applet is the runtime environment for Pypestream platform functionality on a given website.",
            "status": "Cloud",
            "trigger": {
              "title": "Trigger",
              "label": "You haven't set a triggers"
            },
            "actions": {
              "title": "Actions",
              "label": "You haven't set an actions"
            }
          },
          "platformSection": {
            "title": "Platform Integrations",
            "addButton": "Add Integrations"
          },
          "summarySection": {
            "developmentUrls": "{{environmentName}} URLs",
            "appInterfaces": "App Interfaces",
            "variables": "Variables"
          },
          "caption": "Environments",
          "environmentName": "{{environmentName}}",
          "description": "Projects organize work around an online property like a website. Everything in the project must be tied to a domain and, optionally, its subdomains.",
          "addEnvironmentUrl": "Add {{environmentName}} URL",
          "gqlPlaygroundsButton": "GQL playground for Applets"
        }
      },
      "createProject": {
        "step1": {
          "title": "Create a project",
          "name": "Project name",
          "description": "Description (optional)",
          "icon": "Project Icon (optional)"
        },
        "step2": {
          "title": "Environments URLs",
          "field1": "Production",
          "field1Button": "Add Production URL",
          "field2": "Staging",
          "field2Button": "Add Staging URL",
          "field3": "Development",
          "field3Button": "Add Development URL",
          "errors": {
            "default": "This field should be a valid url.",
            "invalidDomain": "The top level domain is invalid",
            "invalidURL": "The URL is invalid",
            "intersection": "This URL ({{intersection}}) is used in another project"
          }
        },
        "step3": {
          "title": "Select tooling to integrate",
          "required": "Please select one or more tools"
        },
        "step4": {
          "title": "Localization"
        },
        "step5": {
          "title": "Success!",
          "subTitle": "New project has been created...",
          "button": "Done"
        },
        "required": "This is a required field",
        "nextStep": "Next",
        "backStep": "Back"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "super-admin",
    "translations": {
      "title": "Super Admin",
      "permission": "You don&apos;t have permission to see this page",
      "section1": {
        "title": "This button is for making a snapshot of DB",
        "button": "Make Snapshot"
      },
      "section2": {
        "title": "Link to Analytics Settings Page",
        "button": "Analytics"
      },
      "section3": {
        "title": "Link to Contact Center Super Admin Page",
        "button": "Contact Center"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "teams",
    "translations": {
      "teamsList": {
        "teams": "Teams",
        "createTeam": "Create Team",
        "table": {
          "name": "Name",
          "users": "Users",
          "updated": "Last updated"
        },
        "createToGetStarted": "Create a team to get started."
      },
      "teamDetails": {
        "createTeam": "Create Team",
        "deleteTeam": "Delete Team",
        "teamInfo": {
          "name": "Name",
          "description": "Description",
          "contactCenterAccess": "Giving a Team access to a Contact Center instance creates a linked Team in that instance. Teams can only be managed here, not in Contact Center."
        },
        "teamUsers": {
          "teamMembers": "Team Members",
          "teamMembersSubTitle": "Team members inherit all roles assigned to the Team.",
          "teamMembersOtherOrgs": "Team Members in Other Orgs",
          "teamMembersOtherOrgsSubTitle": "Team members in other Orgs cannot be managed from this screen. To remove them from this Team, go to their user settings.",
          "user": "User",
          "lastActive": "Last Active",
          "addUsers": "Add Users",
          "noUsers": "There are no users in this Org",
          "noUsersInTeam": "There are no users in this team."
        },
        "deleteTeamModal": {
          "mainTitle": "Delete team {{teamName}}?",
          "subTitle": "Deleting {{teamName}} will:",
          "line1": "Remove inherited roles from all users in this team",
          "line2": "Delete any linked teams in associated Contact Center instances",
          "cancel": "Cancel",
          "delete": "Delete",
          "deleting": "Deleting..."
        },
        "snackbar": {
          "createTeamText": "When you are ready, create the team",
          "updateTeamText": "There are unsaved changes",
          "cancel": "Cancel",
          "create": "Create Team",
          "creating": "Creating Team...",
          "update": "Save Changes",
          "updating": "Saving Changes..."
        },
        "permissionAndAccessTitle": "Roles"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "manager",
    "file": "users",
    "translations": {
      "usersList": {
        "users": "Users",
        "inviteUser": "Invite User",
        "importUsers": "Import Users",
        "importing": "Importing...",
        "createUser": "Create User",
        "bulkInviteUsers": "Bulk Invite",
        "bulkInviting": "Inviting...",
        "table": {
          "name": "Name",
          "email": "Email",
          "lastActive": "Last Active",
          "invited": "Invited"
        },
        "createToGetStarted": "Create a user to get started."
      },
      "userDetails": {
        "title": "User Details",
        "permissionAndAccessTitle": "Roles",
        "deleteUserConfirmationModal": {
          "description": "This will remove all of their access. This cannot be undone.",
          "title": "Delete {{userName}}?"
        },
        "agentConversationLimit": "Agent Conversation Limit",
        "agentConversationLimitTooltip": "Maximum number of conversations that an agent can be assigned at one time.",
        "smartOrgMenu": "Smart Org Menu",
        "smartOrgMenuTooltip": "Shows only Orgs where you have access to at least one Tool or are a member of a Team. Parent Orgs stay visible if they contain visible child Orgs. Your top Org stays visible."
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "manager",
    "file": "common",
    "translations": {
      "cancel": "lorem",
      "save": "lorem",
      "genericError": "Something went wrong. Try again"
    }
  },
  {
    "lang": "hi",
    "namespace": "manager",
    "file": "preferences",
    "translations": {
      "title": "lorem",
      "general": {
        "details": "lorem",
        "name": "lorem",
        "email_address": "lorem",
        "job_title": "lorem",
        "profile_picture": "lorem",
        "cookie_policy": "lorem",
        "other_policies": "lorem",
        "reset_password": "lorem",
        "reset_password_help": "lorem",
        "language_timezone": "lorem",
        "default_language": "lorem",
        "default_timezone": "lorem",
        "add_job_title": "lorem",
        "add_name": "lorem",
        "add_surname": "lorem",
        "add_email_address": "lorem",
        "cookie_policy_label_prefix": "lorem",
        "cookie_policy_label_suffix": "lorem",
        "privacy_policy": "lorem",
        "terms_conditions": "lorem",
        "dsar_form": "lorem",
        "upload_profile_picture_on_google": "lorem",
        "upload_a_file_here": "lorem",
        "select_a_language": "lorem",
        "select_a_time_zone": "lorem",
        "applies_only_to_manager": "lorem"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "manager",
    "file": "common",
    "translations": {
      "cancel": "lorem",
      "save": "lorem",
      "genericError": "Something went wrong. Try again"
    }
  },
  {
    "lang": "ru",
    "namespace": "manager",
    "file": "preferences",
    "translations": {
      "title": "lorem",
      "general": {
        "details": "lorem",
        "name": "lorem",
        "email_address": "lorem",
        "job_title": "lorem",
        "profile_picture": "lorem",
        "cookie_policy": "lorem",
        "other_policies": "lorem",
        "reset_password": "lorem",
        "reset_password_help": "lorem",
        "language_timezone": "lorem",
        "default_language": "lorem",
        "default_timezone": "lorem",
        "add_job_title": "lorem",
        "add_name": "lorem",
        "add_surname": "lorem",
        "add_email_address": "lorem",
        "cookie_policy_label_prefix": "lorem",
        "cookie_policy_label_suffix": "lorem",
        "privacy_policy": "lorem",
        "terms_conditions": "lorem",
        "dsar_form": "lorem",
        "upload_profile_picture_on_google": "lorem",
        "upload_a_file_here": "lorem",
        "select_a_language": "lorem",
        "select_a_time_zone": "lorem",
        "applies_only_to_manager": "lorem"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "manager",
    "file": "common",
    "translations": {
      "cancel": "lorem",
      "save": "lorem",
      "genericError": "Something went wrong. Try again"
    }
  },
  {
    "lang": "zh",
    "namespace": "manager",
    "file": "preferences",
    "translations": {
      "title": "lorem",
      "general": {
        "details": "lorem",
        "name": "lorem",
        "email_address": "lorem",
        "job_title": "lorem",
        "profile_picture": "lorem",
        "cookie_policy": "lorem",
        "other_policies": "lorem",
        "reset_password": "lorem",
        "reset_password_help": "lorem",
        "language_timezone": "lorem",
        "default_language": "lorem",
        "default_timezone": "lorem",
        "add_job_title": "lorem",
        "add_name": "lorem",
        "add_surname": "lorem",
        "add_email_address": "lorem",
        "cookie_policy_label_prefix": "lorem",
        "cookie_policy_label_suffix": "lorem",
        "privacy_policy": "lorem",
        "terms_conditions": "lorem",
        "dsar_form": "lorem",
        "upload_profile_picture_on_google": "lorem",
        "upload_a_file_here": "lorem",
        "select_a_language": "lorem",
        "select_a_time_zone": "lorem",
        "applies_only_to_manager": "lorem"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "navigation",
    "file": "common",
    "translations": {
      "logo": {
        "prefix": "لـ"
      },
      "mega": {
        "sidebar": {
          "title": "المشاريع",
          "empty": "لا توجد مشاريع متاحة",
          "goHome": "الرئيسية",
          "home": "الرئيسية",
          "error": "لقد حدث خطأ ما. يرجى إعادة تحميل الصفحة."
        },
        "content": {
          "title": "الاختصارات",
          "empty": {
            "part1": "اختر",
            "part2": "مشروعًا",
            "part3": "من القائمة للبدء"
          },
          "help": {
            "part1": "تحتاج إلى مساعدة في شيء؟ تواصل مع أخصائي",
            "part2": "هنا"
          }
        }
      },
      "userDropdown": {
        "superAdmin": "المشرف العام",
        "userAccount": "حسابي",
        "logout": "تسجيل الخروج"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "navigation",
    "file": "common",
    "translations": {
      "logo": {
        "prefix": "for"
      },
      "mega": {
        "sidebar": {
          "title": "Projects",
          "empty": "No available projects",
          "goHome": "Go Home",
          "home": "Home",
          "error": "Somethings went wrong. Please reload page."
        },
        "content": {
          "title": "Shortcuts",
          "empty": {
            "part1": "Select a",
            "part2": "project",
            "part3": "from the menu to get started"
          },
          "help": {
            "part1": "Need help with something? Contact a specialist",
            "part2": "here"
          }
        }
      },
      "userDropdown": {
        "superAdmin": "Super Admin",
        "userAccount": "My Account",
        "logout": "Logout"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "navigation",
    "file": "common",
    "translations": {
      "logo": {
        "prefix": "for"
      },
      "mega": {
        "sidebar": {
          "title": "Projects",
          "empty": "No available projects",
          "home": "होम",
          "goHome": "होम पर जाएं"
        },
        "content": {
          "title": "Shortcuts",
          "empty": {
            "part1": "Select a",
            "part2": "project",
            "part3": "from the menu to get started"
          },
          "help": {
            "part1": "Need help with something? Contact a specialist",
            "part2": "here"
          }
        }
      },
      "userDropdown": {
        "logout": "Logout"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "navigation",
    "file": "common",
    "translations": {
      "logo": {
        "prefix": "for"
      },
      "mega": {
        "sidebar": {
          "title": "Projects",
          "empty": "No available projects",
          "home": "Главная",
          "goHome": "Вернуться домой"
        },
        "content": {
          "title": "Shortcuts",
          "empty": {
            "part1": "Select a",
            "part2": "project",
            "part3": "from the menu to get started"
          },
          "help": {
            "part1": "Need help with something? Contact a specialist",
            "part2": "here"
          }
        }
      },
      "userDropdown": {
        "logout": "Logout"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "navigation",
    "file": "common",
    "translations": {
      "logo": {
        "prefix": "for"
      },
      "mega": {
        "sidebar": {
          "title": "Projects",
          "empty": "No available projects",
          "home": "首页",
          "goHome": "返回首页"
        },
        "content": {
          "title": "Shortcuts",
          "empty": {
            "part1": "Select a",
            "part2": "project",
            "part3": "from the menu to get started"
          },
          "help": {
            "part1": "Need help with something? Contact a specialist",
            "part2": "here"
          }
        }
      },
      "userDropdown": {
        "logout": "Logout"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "onboarding",
    "file": "common",
    "translations": {
      "title": "إنهاء إعداد ملفك الشخصي",
      "subTitle": "باقي بضع أسئلة فقط لك...",
      "firstName": "الاسم الأول",
      "lastName": "الاسم الأخير",
      "picture": "الصورة الشخصية",
      "upload_profile_picture_on_google": "لتغيير الصورة أو إزالتها، قم بزيارة حسابك على Google",
      "upload_a_file_here": "ارفع ملفًا هنا",
      "selectFile": "حدد ملفًا",
      "changePicture": "تغيير الصورة الشخصية",
      "jobTitle": "المسمى الوظيفي",
      "terms_conditions_prefix": "الموافقة على",
      "terms_conditions": "الشروط والأحكام",
      "and": "و",
      "privacy_policy": "سياسة الخصوصية",
      "cookie_policy_label_prefix": "الموافقة على",
      "cookie_policy": "سياسة ملفات تعريف الارتباط",
      "cookie_policy_label_suffix": "لمساعدتنا في تحسين تجربتك",
      "button": "حفظ التغييرات",
      "loading": "جاري التحميل..."
    }
  },
  {
    "lang": "en",
    "namespace": "onboarding",
    "file": "common",
    "translations": {
      "title": "Finish up your profile",
      "subTitle": "Just a couple more questions for you...",
      "firstName": "First Name",
      "lastName": "Last Name",
      "picture": "Profile Picture",
      "upload_profile_picture_on_google": "To replace or remove, visit your Google account",
      "upload_a_file_here": "Upload a file here",
      "selectFile": "Select a file",
      "changePicture": "Change profile picture",
      "jobTitle": "Job Title",
      "terms_conditions_prefix": "Agree to",
      "terms_conditions": "Terms and Conditions",
      "and": "and",
      "privacy_policy": "Privacy Policy",
      "cookie_policy_label_prefix": "Opt in to the",
      "cookie_policy": "Cookie Policy",
      "cookie_policy_label_suffix": "to help us improve your experience",
      "button": "Save Changes",
      "loading": "Loading..."
    }
  },
  {
    "lang": "hi",
    "namespace": "onboarding",
    "file": "common",
    "translations": {
      "welcome": "स्वागत है"
    }
  },
  {
    "lang": "ru",
    "namespace": "onboarding",
    "file": "common",
    "translations": {
      "welcome": "Добро пожаловать"
    }
  },
  {
    "lang": "zh",
    "namespace": "onboarding",
    "file": "common",
    "translations": {
      "welcome": "欢迎"
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "actions",
    "translations": {
      "title": "_Actions",
      "subtitle": {
        "part1": "_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read",
        "part2": "_the documentation"
      },
      "section1": {
        "title": "_Configuration",
        "label": "_File Name",
        "action": "_Upload Config"
      },
      "section2": {
        "title": "_Functions",
        "label": "_File Name",
        "action": "_Upload Scripts"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this script?"
      },
      "editorModal": {
        "save": {
          "label": "_Save",
          "progress": "_Saving"
        },
        "cancel": "_Cancel"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "channel-details",
    "translations": {
      "title": {
        "create": "_Create Channel",
        "update": "_Update Channel"
      },
      "form": {
        "titles": {
          "channel-details": "_Channel Details",
          "branding-options": "_Branding Options",
          "sizing-options": "_Sizing Options",
          "agent-support-platform": "_Agent Support Platform",
          "preview": "_Preview"
        },
        "labels": {
          "channel-name": "_Channel Name",
          "environment": "_Environment",
          "logo": "_Logo",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "account-id": "_Account Id",
          "inbox-id": "_Inbox Id",
          "or": "_or"
        },
        "placeholders": {
          "channel-name": "_Channel Name",
          "environment": "_Select Environment",
          "logo": "_Logo URL",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "pixels": "_Pixels"
        },
        "validation-messages": {
          "integration": "_This field is required when other agent support fields are filled",
          "env": "_Environment is required",
          "name": "_Channel name is required",
          "projectId": "_Project ID is required",
          "customerId": "_Customer ID is required"
        },
        "help-texts": {
          "env": "_Cannot be changed after channel is created.",
          "preview": "_The position and size of the channel are not reflected in this preview."
        },
        "buttons": {
          "cancel": "_Cancel",
          "save": "_Save",
          "reset": "_Reset",
          "edit": "_Edit Style Sheet"
        }
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "channels",
    "translations": {
      "title": "_Channels",
      "subtitle": "_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).",
      "add_channel": "_Add Channel",
      "table": {
        "column1": "_Name",
        "column2": "_Environment",
        "column3": "_Last edited"
      },
      "deleteChannelModal": {
        "title": "_Are you sure?",
        "description": "_Are you sure you want to delete this channel? Users will no longer be able to access your microapp using it.",
        "cancel": "_Cancel",
        "delete": "_Remove Channel"
      },
      "toasts": {
        "appIdCopied": "_App ID has been copied to your clipboard.",
        "embedCodeCopied": "_Embed code has been copied to your clipboard."
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "common",
    "translations": {
      "product": "_Pro Studio",
      "loading": "_Loading",
      "orgPrefix": "_for",
      "versionPrefix": "_from",
      "userNamePrefix": "_by",
      "environments": {
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "versions": {
        "draft": "_Draft",
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "deleteFilePopover": {
        "cancel": "_Cancel",
        "delete": "_Delete"
      },
      "deleteTaskModal": {
        "title": "_Delete Task?",
        "description": "_Are you sure you want to delete \"{{taskName}}\"? This will also remove the associated decision node from the workflow.",
        "cancel": "_Cancel",
        "delete": "_Delete"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "files",
    "translations": {
      "title": "_Media and Files",
      "description": {
        "part1": "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        "part2": "_Designing Agents"
      },
      "filepond": {
        "previewLabel": "_Drag a file here"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this asset?"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "homepage",
    "translations": {
      "title": "_Solutions",
      "create": "_Create Solution",
      "table": {
        "column1": "_Solution Name",
        "column2": "_Last Updated"
      },
      "modal": {
        "title": "_Create Solution",
        "form": {
          "name": {
            "placeholder": "_SolutionName",
            "validation": {
              "uniqueness": "_Uniqueness",
              "safety": "_Safety"
            }
          }
        },
        "buttons": {
          "create": "_Create",
          "creating": "_Creating..."
        }
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "navigation",
    "translations": {
      "nav_links": {
        "versions": "_Versions",
        "channels": "_Channels",
        "actions": "_Actions",
        "workflows": "_Workflows",
        "publish": "_Publish",
        "files": "_Files"
      },
      "settings": {
        "title": "_Solution Type",
        "radio_group": {
          "radio1": "_Main",
          "radio2": "_Survey",
          "radio3": "_Unknown"
        },
        "button": "_Delete"
      },
      "delete_solution_modal": {
        "title": "_Delete this solution?",
        "subtitle": {
          "part1": "_Deleting",
          "part2": "_deletes all associated data. This does not affect solutions in other Projects."
        },
        "verify": {
          "part1": "_To verify, type",
          "part2": "_below"
        },
        "buttons": {
          "decline": "_Cancel",
          "accept": "_Delete"
        }
      },
      "publish_modal": {
        "title": {
          "part1": "_Publish",
          "solution_type": "_Survey"
        },
        "button": {
          "static": "_Publish",
          "loading": "_Publishing..."
        },
        "form": {
          "part1": {
            "title": "_Please choose the environment below:",
            "select": {
              "placeholder": "_Select option..."
            }
          },
          "part2": {
            "title": "_For the following solution",
            "select": {
              "placeholder": "_Select solution"
            }
          }
        }
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "versions",
    "translations": {
      "duplo_cloud_id": {
        "copy": "_Copy DuploCloud ID",
        "message": "_DuploCloud ID copied to clipboard"
      },
      "cards": {
        "title": "_Environments",
        "button": "_Edit Workflows",
        "empty": "_To create a new draft, make an edit in the Workflows tab or load an older version.",
        "draft_date_label": "_Last edited",
        "no_published_label": "_Nothing has been published on the {{env}} Environment."
      },
      "table": {
        "title": "_Publishing versions",
        "column1": "_Version",
        "column2": "_Environment",
        "column3": "_Last published",
        "buttons": {
          "load_as_draft": "_Load as draft",
          "republish": "_Republish"
        }
      },
      "load_as_draft_modal": {
        "title": {
          "part1": "_Load",
          "part2": "_as draft"
        },
        "radio_group": {
          "radio1": "_Restore all files",
          "radio2": "_Restore without Actions"
        },
        "button": "_Confirm"
      },
      "republish_modal": {
        "title": "_Republish",
        "subtitle": "_Please choose the environment below:",
        "button": {
          "static": "_Republish",
          "loading": "_Republishing..."
        },
        "select": {
          "placeholder": "_Select environment"
        },
        "radio_group": {
          "radio1": "_Republish all files",
          "radio2": "_Republish without Actions"
        }
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pro-studio",
    "file": "workflows",
    "translations": {
      "csv_upload_modal": {
        "title": "_Replace all nodes in this solution?",
        "subtitle": "_Importing this CSV will replace all nodes in this solution.",
        "buttons": {
          "save": "_Replace Nodes",
          "cancel": "_Cancel"
        }
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "actions",
    "translations": {
      "title": "Actions",
      "subtitle": {
        "part1": "Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read",
        "part2": "the documentation"
      },
      "section1": {
        "title": "Configuration",
        "label": "File Name",
        "action": "Upload Config"
      },
      "section2": {
        "title": "Functions",
        "label": "File Name",
        "action": "Upload Scripts"
      },
      "deleteFilePopover": {
        "title": "Are you sure you want to delete this script?"
      },
      "editorModal": {
        "save": {
          "label": "Save",
          "progress": "Saving"
        },
        "cancel": "Cancel"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "channel-details",
    "translations": {
      "title": {
        "create": "Create Channel",
        "update": "Update Channel"
      },
      "form": {
        "titles": {
          "channel-details": "Channel Details",
          "branding-options": "Branding Options",
          "sizing-options": "Sizing Options",
          "agent-support-platform": "Agent Support Platform",
          "preview": "Preview"
        },
        "labels": {
          "channel-name": "Channel Name",
          "environment": "Environment",
          "logo": "Logo",
          "brand-moment-url": "Brand Moment URL",
          "brand-color": "Brand Color",
          "solution-bubble-color": "Solution Bubble Color",
          "solution-text-color": "Solution Text Color",
          "user-bubble-color": "User Bubble Color",
          "user-text-color": "User Text Color",
          "button-color": "Button Color",
          "button-text-color": "Button Text Color",
          "width": "Width",
          "height": "Height",
          "account-id": "Account Id",
          "inbox-id": "Inbox Id",
          "or": "or"
        },
        "placeholders": {
          "channel-name": "Channel Name",
          "environment": "Select Environment",
          "logo": "Logo URL",
          "brand-moment-url": "Brand Moment URL",
          "brand-color": "Brand Color",
          "solution-bubble-color": "Solution Bubble Color",
          "solution-text-color": "Solution Text Color",
          "user-bubble-color": "User Bubble Color",
          "user-text-color": "User Text Color",
          "button-color": "Button Color",
          "button-text-color": "Button Text Color",
          "width": "Width",
          "height": "Height",
          "pixels": "Pixels"
        },
        "validation-messages": {
          "integration": "This field is required when other agent support fields are filled",
          "env": "Environment is required",
          "name": "Channel name is required",
          "projectId": "Project ID is required",
          "customerId": "Customer ID is required"
        },
        "help-texts": {
          "env": "Cannot be changed after channel is created.",
          "preview": "The position and size of the channel are not reflected in this preview."
        },
        "buttons": {
          "cancel": "Cancel",
          "save": "Save",
          "reset": "Reset",
          "edit": "Edit Style Sheet"
        }
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "channels",
    "translations": {
      "title": "Channels",
      "subtitle": "Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).",
      "addchannel": "Add Channel",
      "table": {
        "column1": "Name",
        "column2": "Environment",
        "column3": "Last edited"
      },
      "deleteChannelModal": {
        "title": "Are you sure?",
        "description": "Are you sure you want to delete this channel? Users will no longer be able to access your microapp using it.",
        "cancel": "Cancel",
        "delete": "Remove Channel"
      },
      "toasts": {
        "appIdCopied": "App ID has been copied to your clipboard.",
        "embedCodeCopied": "Embed code has been copied to your clipboard."
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "common",
    "translations": {
      "product": "Pro Studio",
      "loading": "Loading",
      "orgPrefix": "for",
      "versionPrefix": "from",
      "userNamePrefix": "by",
      "environments": {
        "sandbox": "Sandbox",
        "live": "Live"
      },
      "versions": {
        "draft": "Draft",
        "sandbox": "Sandbox",
        "live": "Live"
      },
      "deleteFilePopover": {
        "cancel": "Cancel",
        "delete": "Delete"
      },
      "deleteTaskModal": {
        "title": "Delete Task?",
        "description": "Are you sure you want to delete \"{{taskName}}\"? This will also remove the associated decision node from the workflow.",
        "cancel": "Cancel",
        "delete": "Delete"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "files",
    "translations": {
      "title": "Media and Files",
      "description": {
        "part1": "In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        "part2": "Designing Agents"
      },
      "filepond": {
        "previewLabel": "Drag a file here"
      },
      "deleteFilePopover": {
        "title": "Are you sure you want to delete this asset?"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "homepage",
    "translations": {
      "title": "Solutions",
      "create": "Create Solution",
      "table": {
        "column1": "Solution Title",
        "column2": "Last Updated"
      },
      "modal": {
        "title": "Create Solution",
        "form": {
          "name": {
            "placeholder": "Solution Title",
            "validation": {
              "uniqueness": "Uniqueness",
              "safety": "Safety"
            }
          }
        },
        "buttons": {
          "create": "Create",
          "creating": "Creating..."
        }
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "navigation",
    "translations": {
      "nav_links": {
        "versions": "Versions",
        "channels": "Channels",
        "actions": "Actions",
        "workflows": "Workflows",
        "publish": "Publish",
        "files": "Files"
      },
      "settings": {
        "title": "Solution Type",
        "radio_group": {
          "radio1": "Main",
          "radio2": "Survey",
          "radio3": "Unknown"
        },
        "button": "Delete"
      },
      "delete_solution_modal": {
        "title": "Delete this solution?",
        "subtitle": {
          "part1": "Deleting",
          "part2": "deletes all associated data. This does not affect solutions in other Projects."
        },
        "verify": {
          "part1": "To verify, type",
          "part2": "below"
        },
        "buttons": {
          "decline": "Cancel",
          "accept": "Delete"
        }
      },
      "publish_modal": {
        "title": {
          "part1": "Publish",
          "solution_type": "Survey"
        },
        "button": {
          "static": "Publish",
          "loading": "Publishing..."
        },
        "form": {
          "part1": {
            "title": "Please choose the environment below:",
            "select": {
              "placeholder": "Select environment"
            }
          },
          "part2": {
            "title": "For the following solution",
            "select": {
              "placeholder": "Select solution"
            }
          }
        }
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "versions",
    "translations": {
      "duplo_cloud_id": {
        "copy": "Copy DuploCloud ID",
        "message": "DuploCloud ID copied to clipboard"
      },
      "cards": {
        "title": "Environments",
        "button": "Edit Workflows",
        "empty": "To create a new draft, make an edit in the Workflows tab or load an older version.",
        "draft_date_label": "Last edited",
        "no_published_label": "Nothing has been published on the {{env}} Environment."
      },
      "table": {
        "title": "Publishing versions",
        "column1": "Version",
        "column2": "Environment",
        "column3": "Last published",
        "buttons": {
          "load_as_draft": "Load as draft",
          "republish": "Republish"
        }
      },
      "load_as_draft_modal": {
        "title": {
          "part1": "Load",
          "part2": "as draft"
        },
        "radio_group": {
          "radio1": "Restore all files",
          "radio2": "Restore without Actions"
        },
        "button": "Confirm"
      },
      "republish_modal": {
        "title": "Republish",
        "subtitle": "Please choose the environment below:",
        "button": {
          "static": "Republish",
          "loading": "Republishing..."
        },
        "select": {
          "placeholder": "Select environment"
        },
        "radio_group": {
          "radio1": "Republish all files",
          "radio2": "Republish without Actions"
        }
      }
    }
  },
  {
    "lang": "en",
    "namespace": "pro-studio",
    "file": "workflows",
    "translations": {
      "csv_upload_modal": {
        "title": "Replace all nodes in this solution?",
        "subtitle": "Importing this CSV will replace all nodes in this solution.",
        "buttons": {
          "save": "Replace Nodes",
          "cancel": "Cancel"
        }
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "actions",
    "translations": {
      "title": "_Actions",
      "subtitle": {
        "part1": "_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read",
        "part2": "_the documentation"
      },
      "section1": {
        "title": "_Configuration",
        "label": "_File Name",
        "action": "_Upload Config"
      },
      "section2": {
        "title": "_Functions",
        "label": "_File Name",
        "action": "_Upload Scripts"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this script?"
      },
      "editorModal": {
        "save": {
          "label": "_Save",
          "progress": "_Saving"
        },
        "cancel": "_Cancel"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "channel-details",
    "translations": {
      "title": {
        "create": "_Create Channel",
        "update": "_Update Channel"
      },
      "form": {
        "titles": {
          "channel-details": "_Channel Details",
          "branding-options": "_Branding Options",
          "sizing-options": "_Sizing Options",
          "agent-support-platform": "_Agent Support Platform",
          "preview": "_Preview"
        },
        "labels": {
          "channel-name": "_Channel Name",
          "environment": "_Environment",
          "logo": "_Logo",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "account-id": "_Account Id",
          "inbox-id": "_Inbox Id",
          "or": "_or"
        },
        "placeholders": {
          "channel-name": "_Channel Name",
          "environment": "_Select Environment",
          "logo": "_Logo URL",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "pixels": "_Pixels"
        },
        "validation-messages": {
          "integration": "_This field is required when other agent support fields are filled",
          "env": "_Environment is required",
          "name": "_Channel name is required",
          "projectId": "_Project ID is required",
          "customerId": "_Customer ID is required"
        },
        "help-texts": {
          "env": "_Cannot be changed after channel is created.",
          "preview": "_The position and size of the channel are not reflected in this preview."
        },
        "buttons": {
          "cancel": "_Cancel",
          "save": "_Save",
          "reset": "_Reset",
          "edit": "_Edit Style Sheet"
        }
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "channels",
    "translations": {
      "title": "_Channels",
      "subtitle": "_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).",
      "add_channel": "_Add Channel",
      "table": {
        "column1": "_Name",
        "column2": "_Environment",
        "column3": "_Last edited"
      },
      "deleteChannelModal": {
        "title": "_Are you sure?",
        "description": "_Are you sure you want to delete this channel? Users will no longer be able to access your microapp using it.",
        "cancel": "_Cancel",
        "delete": "_Remove Channel"
      },
      "toasts": {
        "appIdCopied": "_App ID has been copied to your clipboard.",
        "embedCodeCopied": "_Embed code has been copied to your clipboard."
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "common",
    "translations": {
      "product": "_Pro Studio",
      "loading": "_Loading",
      "orgPrefix": "_for",
      "versionPrefix": "_from",
      "userNamePrefix": "_by",
      "environments": {
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "versions": {
        "draft": "_Draft",
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "deleteFilePopover": {
        "cancel": "_Cancel",
        "delete": "_Delete"
      },
      "deleteTaskModal": {
        "title": "_Delete Task?",
        "description": "_Are you sure you want to delete \"{{taskName}}\"? This will also remove the associated decision node from the workflow.",
        "cancel": "_Cancel",
        "delete": "_Delete"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "files",
    "translations": {
      "title": "_Media and Files",
      "description": {
        "part1": "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        "part2": "_Designing Agents"
      },
      "filepond": {
        "previewLabel": "_Drag a file here"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this asset?"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "homepage",
    "translations": {
      "title": "_Solutions",
      "create": "_Create Solution",
      "table": {
        "column1": "_Solution Name",
        "column2": "_Last Updated"
      },
      "modal": {
        "title": "_Create Solution",
        "form": {
          "name": {
            "placeholder": "_SolutionName",
            "validation": {
              "uniqueness": "_Uniqueness",
              "safety": "_Safety"
            }
          }
        },
        "buttons": {
          "create": "_Create",
          "creating": "_Creating..."
        }
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "navigation",
    "translations": {
      "nav_links": {
        "versions": "_Versions",
        "channels": "_Channels",
        "actions": "_Actions",
        "workflows": "_Workflows",
        "publish": "_Publish",
        "files": "_Files"
      },
      "settings": {
        "title": "_Solution Type",
        "radio_group": {
          "radio1": "_Main",
          "radio2": "_Survey",
          "radio3": "_Unknown"
        },
        "button": "_Delete"
      },
      "delete_solution_modal": {
        "title": "_Delete this solution?",
        "subtitle": {
          "part1": "_Deleting",
          "part2": "_deletes all associated data. This does not affect solutions in other Projects."
        },
        "verify": {
          "part1": "_To verify, type",
          "part2": "_below"
        },
        "buttons": {
          "decline": "_Cancel",
          "accept": "_Delete"
        }
      },
      "publish_modal": {
        "title": {
          "part1": "_Publish",
          "solution_type": "_Survey"
        },
        "button": {
          "static": "_Publish",
          "loading": "_Publishing..."
        },
        "form": {
          "part1": {
            "title": "_Please choose the environment below:",
            "select": {
              "placeholder": "_Select option..."
            }
          },
          "part2": {
            "title": "_For the following solution",
            "select": {
              "placeholder": "_Select solution"
            }
          }
        }
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "versions",
    "translations": {
      "duplo_cloud_id": {
        "copy": "_Copy DuploCloud ID",
        "message": "_DuploCloud ID copied to clipboard"
      },
      "cards": {
        "title": "_Environments",
        "button": "_Edit Workflows",
        "empty": "_To create a new draft, make an edit in the Workflows tab or load an older version.",
        "draft_date_label": "_Last edited",
        "no_published_label": "_Nothing has been published on the {{env}} Environment."
      },
      "table": {
        "title": "_Publishing versions",
        "column1": "_Version",
        "column2": "_Environment",
        "column3": "_Last published",
        "buttons": {
          "load_as_draft": "_Load as draft",
          "republish": "_Republish"
        }
      },
      "load_as_draft_modal": {
        "title": {
          "part1": "_Load",
          "part2": "_as draft"
        },
        "radio_group": {
          "radio1": "_Restore all files",
          "radio2": "_Restore without Actions"
        },
        "button": "_Confirm"
      },
      "republish_modal": {
        "title": "_Republish",
        "subtitle": "_Please choose the environment below:",
        "button": {
          "static": "_Republish",
          "loading": "_Republishing..."
        },
        "select": {
          "placeholder": "_Select environment"
        },
        "radio_group": {
          "radio1": "_Republish all files",
          "radio2": "_Republish without Actions"
        }
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "pro-studio",
    "file": "workflows",
    "translations": {
      "csv_upload_modal": {
        "title": "_Replace all nodes in this solution?",
        "subtitle": "_Importing this CSV will replace all nodes in this solution.",
        "buttons": {
          "save": "_Replace Nodes",
          "cancel": "_Cancel"
        }
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "actions",
    "translations": {
      "title": "_Actions",
      "subtitle": {
        "part1": "_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read",
        "part2": "_the documentation"
      },
      "section1": {
        "title": "_Configuration",
        "label": "_File Name",
        "action": "_Upload Config"
      },
      "section2": {
        "title": "_Functions",
        "label": "_File Name",
        "action": "_Upload Scripts"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this script?"
      },
      "editorModal": {
        "save": {
          "label": "_Save",
          "progress": "_Saving"
        },
        "cancel": "_Cancel"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "channel-details",
    "translations": {
      "title": {
        "create": "_Create Channel",
        "update": "_Update Channel"
      },
      "form": {
        "titles": {
          "channel-details": "_Channel Details",
          "branding-options": "_Branding Options",
          "sizing-options": "_Sizing Options",
          "agent-support-platform": "_Agent Support Platform",
          "preview": "_Preview"
        },
        "labels": {
          "channel-name": "_Channel Name",
          "environment": "_Environment",
          "logo": "_Logo",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "account-id": "_Account Id",
          "inbox-id": "_Inbox Id",
          "or": "_or"
        },
        "placeholders": {
          "channel-name": "_Channel Name",
          "environment": "_Select Environment",
          "logo": "_Logo URL",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "pixels": "_Pixels"
        },
        "validation-messages": {
          "integration": "_This field is required when other agent support fields are filled",
          "env": "_Environment is required",
          "name": "_Channel name is required",
          "projectId": "_Project ID is required",
          "customerId": "_Customer ID is required"
        },
        "help-texts": {
          "env": "_Cannot be changed after channel is created.",
          "preview": "_The position and size of the channel are not reflected in this preview."
        },
        "buttons": {
          "cancel": "_Cancel",
          "save": "_Save",
          "reset": "_Reset",
          "edit": "_Edit Style Sheet"
        }
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "channels",
    "translations": {
      "title": "_Channels",
      "subtitle": "_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).",
      "add_channel": "_Add Channel",
      "table": {
        "column1": "_Name",
        "column2": "_Environment",
        "column3": "_Last edited"
      },
      "deleteChannelModal": {
        "title": "_Are you sure?",
        "description": "_Are you sure you want to delete this channel? Users will no longer be able to access your microapp using it.",
        "cancel": "_Cancel",
        "delete": "_Remove Channel"
      },
      "toasts": {
        "appIdCopied": "_App ID has been copied to your clipboard.",
        "embedCodeCopied": "_Embed code has been copied to your clipboard."
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "common",
    "translations": {
      "product": "_Pro Studio",
      "loading": "_Loading",
      "orgPrefix": "_for",
      "versionPrefix": "_from",
      "userNamePrefix": "_by",
      "environments": {
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "versions": {
        "draft": "_Draft",
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "deleteFilePopover": {
        "cancel": "_Cancel",
        "delete": "_Delete"
      },
      "deleteTaskModal": {
        "title": "_Delete Task?",
        "description": "_Are you sure you want to delete \"{{taskName}}\"? This will also remove the associated decision node from the workflow.",
        "cancel": "_Cancel",
        "delete": "_Delete"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "files",
    "translations": {
      "title": "_Media and Files",
      "description": {
        "part1": "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        "part2": "_Designing Agents"
      },
      "filepond": {
        "previewLabel": "_Drag a file here"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this asset?"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "homepage",
    "translations": {
      "title": "_Solutions",
      "create": "_Create Solution",
      "table": {
        "column1": "_Solution Name",
        "column2": "_Last Updated"
      },
      "modal": {
        "title": "_Create Solution",
        "form": {
          "name": {
            "placeholder": "_SolutionName",
            "validation": {
              "uniqueness": "_Uniqueness",
              "safety": "_Safety"
            }
          }
        },
        "buttons": {
          "create": "_Create",
          "creating": "_Creating..."
        }
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "navigation",
    "translations": {
      "nav_links": {
        "versions": "_Versions",
        "channels": "_Channels",
        "actions": "_Actions",
        "workflows": "_Workflows",
        "publish": "_Publish",
        "files": "_Files"
      },
      "settings": {
        "title": "_Solution Type",
        "radio_group": {
          "radio1": "_Main",
          "radio2": "_Survey",
          "radio3": "_Unknown"
        },
        "button": "_Delete"
      },
      "delete_solution_modal": {
        "title": "_Delete this solution?",
        "subtitle": {
          "part1": "_Deleting",
          "part2": "_deletes all associated data. This does not affect solutions in other Projects."
        },
        "verify": {
          "part1": "_To verify, type",
          "part2": "_below"
        },
        "buttons": {
          "decline": "_Cancel",
          "accept": "_Delete"
        }
      },
      "publish_modal": {
        "title": {
          "part1": "_Publish",
          "solution_type": "_Survey"
        },
        "button": {
          "static": "_Publish",
          "loading": "_Publishing..."
        },
        "form": {
          "part1": {
            "title": "_Please choose the environment below:",
            "select": {
              "placeholder": "_Select option..."
            }
          },
          "part2": {
            "title": "_For the following solution",
            "select": {
              "placeholder": "_Select solution"
            }
          }
        }
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "versions",
    "translations": {
      "duplo_cloud_id": {
        "copy": "_Copy DuploCloud ID",
        "message": "_DuploCloud ID copied to clipboard"
      },
      "cards": {
        "title": "_Environments",
        "button": "_Edit Workflows",
        "empty": "_To create a new draft, make an edit in the Workflows tab or load an older version.",
        "draft_date_label": "_Last edited",
        "no_published_label": "_Nothing has been published on the {{env}} Environment."
      },
      "table": {
        "title": "_Publishing versions",
        "column1": "_Version",
        "column2": "_Environment",
        "column3": "_Last published",
        "buttons": {
          "load_as_draft": "_Load as draft",
          "republish": "_Republish"
        }
      },
      "load_as_draft_modal": {
        "title": {
          "part1": "_Load",
          "part2": "_as draft"
        },
        "radio_group": {
          "radio1": "_Restore all files",
          "radio2": "_Restore without Actions"
        },
        "button": "_Confirm"
      },
      "republish_modal": {
        "title": "_Republish",
        "subtitle": "_Please choose the environment below:",
        "button": {
          "static": "_Republish",
          "loading": "_Republishing..."
        },
        "select": {
          "placeholder": "_Select environment"
        },
        "radio_group": {
          "radio1": "_Republish all files",
          "radio2": "_Republish without Actions"
        }
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "pro-studio",
    "file": "workflows",
    "translations": {
      "csv_upload_modal": {
        "title": "_Replace all nodes in this solution?",
        "subtitle": "_Importing this CSV will replace all nodes in this solution.",
        "buttons": {
          "save": "_Replace Nodes",
          "cancel": "_Cancel"
        }
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "actions",
    "translations": {
      "title": "_Actions",
      "subtitle": {
        "part1": "_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read",
        "part2": "_the documentation"
      },
      "section1": {
        "title": "_Configuration",
        "label": "_File Name",
        "action": "_Upload Config"
      },
      "section2": {
        "title": "_Functions",
        "label": "_File Name",
        "action": "_Upload Scripts"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this script?"
      },
      "editorModal": {
        "save": {
          "label": "_Save",
          "progress": "_Saving"
        },
        "cancel": "_Cancel"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "channel-details",
    "translations": {
      "title": {
        "create": "_Create Channel",
        "update": "_Update Channel"
      },
      "form": {
        "titles": {
          "channel-details": "_Channel Details",
          "branding-options": "_Branding Options",
          "sizing-options": "_Sizing Options",
          "agent-support-platform": "_Agent Support Platform",
          "preview": "_Preview"
        },
        "labels": {
          "channel-name": "_Channel Name",
          "environment": "_Environment",
          "logo": "_Logo",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "account-id": "_Account Id",
          "inbox-id": "_Inbox Id",
          "or": "_or"
        },
        "placeholders": {
          "channel-name": "_Channel Name",
          "environment": "_Select Environment",
          "logo": "_Logo URL",
          "brand-moment-url": "_Brand Moment URL",
          "brand-color": "_Brand Color",
          "solution-bubble-color": "_Solution Bubble Color",
          "solution-text-color": "_Solution Text Color",
          "user-bubble-color": "_User Bubble Color",
          "user-text-color": "_User Text Color",
          "button-color": "_Button Color",
          "button-text-color": "_Button Text Color",
          "width": "_Width",
          "height": "_Height",
          "pixels": "_Pixels"
        },
        "validation-messages": {
          "integration": "_This field is required when other agent support fields are filled",
          "env": "_Environment is required",
          "name": "_Channel name is required",
          "projectId": "_Project ID is required",
          "customerId": "_Customer ID is required"
        },
        "help-texts": {
          "env": "_Cannot be changed after channel is created.",
          "preview": "_The position and size of the channel are not reflected in this preview."
        },
        "buttons": {
          "cancel": "_Cancel",
          "save": "_Save",
          "reset": "_Reset",
          "edit": "_Edit Style Sheet"
        }
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "channels",
    "translations": {
      "title": "_Channels",
      "subtitle": "_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).",
      "add_channel": "_Add Channel",
      "table": {
        "column1": "_Name",
        "column2": "_Environment",
        "column3": "_Last edited"
      },
      "deleteChannelModal": {
        "title": "_Are you sure?",
        "description": "_Are you sure you want to delete this channel? Users will no longer be able to access your microapp using it.",
        "cancel": "_Cancel",
        "delete": "_Remove Channel"
      },
      "toasts": {
        "appIdCopied": "_App ID has been copied to your clipboard.",
        "embedCodeCopied": "_Embed code has been copied to your clipboard."
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "common",
    "translations": {
      "product": "_Pro Studio",
      "loading": "_Loading",
      "orgPrefix": "_for",
      "versionPrefix": "_from",
      "userNamePrefix": "_by",
      "environments": {
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "versions": {
        "draft": "_Draft",
        "sandbox": "_Sandbox",
        "live": "_Live"
      },
      "deleteFilePopover": {
        "cancel": "_Cancel",
        "delete": "_Delete"
      },
      "deleteTaskModal": {
        "title": "_Delete Task?",
        "description": "_Are you sure you want to delete \"{{taskName}}\"? This will also remove the associated decision node from the workflow.",
        "cancel": "_Cancel",
        "delete": "_Delete"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "files",
    "translations": {
      "title": "_Media and Files",
      "description": {
        "part1": "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        "part2": "_Designing Agents"
      },
      "filepond": {
        "previewLabel": "_Drag a file here"
      },
      "deleteFilePopover": {
        "title": "_Are you sure you want to delete this asset?"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "homepage",
    "translations": {
      "title": "_Solutions",
      "create": "_Create Solution",
      "table": {
        "column1": "_Solution Name",
        "column2": "_Last Updated"
      },
      "modal": {
        "title": "_Create Solution",
        "form": {
          "name": {
            "placeholder": "_SolutionName",
            "validation": {
              "uniqueness": "_Uniqueness",
              "safety": "_Safety"
            }
          }
        },
        "buttons": {
          "create": "_Create",
          "creating": "_Creating..."
        }
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "navigation",
    "translations": {
      "nav_links": {
        "versions": "_Versions",
        "channels": "_Channels",
        "actions": "_Actions",
        "workflows": "_Workflows",
        "publish": "_Publish",
        "files": "_Files"
      },
      "settings": {
        "title": "_Solution Type",
        "radio_group": {
          "radio1": "_Main",
          "radio2": "_Survey",
          "radio3": "_Unknown"
        },
        "button": "_Delete"
      },
      "delete_solution_modal": {
        "title": "_Delete this solution?",
        "subtitle": {
          "part1": "_Deleting",
          "part2": "_deletes all associated data. This does not affect solutions in other Projects."
        },
        "verify": {
          "part1": "_To verify, type",
          "part2": "_below"
        },
        "buttons": {
          "decline": "_Cancel",
          "accept": "_Delete"
        }
      },
      "publish_modal": {
        "title": {
          "part1": "_Publish",
          "solution_type": "_Survey"
        },
        "button": {
          "static": "_Publish",
          "loading": "_Publishing..."
        },
        "form": {
          "part1": {
            "title": "_Please choose the environment below:",
            "select": {
              "placeholder": "_Select option..."
            }
          },
          "part2": {
            "title": "_For the following solution",
            "select": {
              "placeholder": "_Select solution"
            }
          }
        }
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "versions",
    "translations": {
      "duplo_cloud_id": {
        "copy": "_Copy DuploCloud ID",
        "message": "_DuploCloud ID copied to clipboard"
      },
      "cards": {
        "title": "_Environments",
        "button": "_Edit Workflows",
        "empty": "_To create a new draft, make an edit in the Workflows tab or load an older version.",
        "draft_date_label": "_Last edited",
        "no_published_label": "_Nothing has been published on the {{env}} Environment."
      },
      "table": {
        "title": "_Publishing versions",
        "column1": "_Version",
        "column2": "_Environment",
        "column3": "_Last published",
        "buttons": {
          "load_as_draft": "_Load as draft",
          "republish": "_Republish"
        }
      },
      "load_as_draft_modal": {
        "title": {
          "part1": "_Load",
          "part2": "_as draft"
        },
        "radio_group": {
          "radio1": "_Restore all files",
          "radio2": "_Restore without Actions"
        },
        "button": "_Confirm"
      },
      "republish_modal": {
        "title": "_Republish",
        "subtitle": "_Please choose the environment below:",
        "button": {
          "static": "_Republish",
          "loading": "_Republishing..."
        },
        "select": {
          "placeholder": "_Select environment"
        },
        "radio_group": {
          "radio1": "_Republish all files",
          "radio2": "_Republish without Actions"
        }
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "pro-studio",
    "file": "workflows",
    "translations": {
      "csv_upload_modal": {
        "title": "_Replace all nodes in this solution?",
        "subtitle": "_Importing this CSV will replace all nodes in this solution.",
        "buttons": {
          "save": "_Replace Nodes",
          "cancel": "_Cancel"
        }
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "pype",
    "file": "common",
    "translations": {
      "welcomeToPype": "Pype مرحبا بكم في"
    }
  },
  {
    "lang": "en",
    "namespace": "pype",
    "file": "common",
    "translations": {
      "welcomeToPype": "welcome to Pype"
    }
  },
  {
    "lang": "hi",
    "namespace": "pype",
    "file": "common",
    "translations": {
      "welcomeToPype": "Pype में आपका स्वागत है"
    }
  },
  {
    "lang": "ru",
    "namespace": "pype",
    "file": "common",
    "translations": {
      "welcomeToPype": "добро пожаловать в пайп"
    }
  },
  {
    "lang": "zh",
    "namespace": "pype",
    "file": "common",
    "translations": {
      "welcomeToPype": "歡迎來到派普"
    }
  },
  {
    "lang": "ar",
    "namespace": "studio",
    "file": "build",
    "translations": {
      "addNewNode": " إضافة ورقة جديدة",
      "simulatingGraphProgress": "{{ progress }} تقدم محاكاة الرسم البياني"
    }
  },
  {
    "lang": "ar",
    "namespace": "studio",
    "file": "common",
    "translations": {
      "loading": "جار التحميل...",
      "saving": "...إنقاذ",
      "error": {
        "title": "هناك خطأ ما:",
        "button": "حاول ثانية"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "studio",
    "file": "homepage",
    "translations": {
      "title": "كل التطبيقات",
      "app": {
        "create": "تطبيق جديد",
        "name": "اسم التطبيق",
        "status": "وضع الإنتاج",
        "updated": "التحديث الاخير"
      },
      "status": {
        "live": "لم يتم نشرها",
        "outdated": "نسخة قديمة",
        "latest": "احدث اصدار",
        "default": "تقصير",
        "primary": "ابتدائي",
        "success": "نجاح",
        "error": "خطأ",
        "warning": "تحذير"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "studio",
    "file": "manage",
    "translations": {
      "activity": "النشاط الأخير",
      "version": "النسخة المحفوظة",
      "unpublished": "غير منشورة"
    }
  },
  {
    "lang": "ar",
    "namespace": "studio",
    "file": "navigation",
    "translations": {
      "main": {
        "manage": "إدارة",
        "home": "مسكن",
        "build": "الكونغرس",
        "analytics": "المحللون"
      },
      "extra": {
        "preview": "شخصي",
        "publish": "نشر التغييرات",
        "signout": "اذهب للخارج"
      }
    }
  },
  {
    "lang": "ar",
    "namespace": "studio",
    "file": "tag",
    "translations": {
      "latest": "الاخير",
      "outdated": "عفا عليها الزمن",
      "live": "ذو صلة"
    }
  },
  {
    "lang": "en",
    "namespace": "studio",
    "file": "build",
    "translations": {
      "addNewNode": "Add new Node",
      "simulatingGraphProgress": "Graph simulation progress is {{ progress }}"
    }
  },
  {
    "lang": "en",
    "namespace": "studio",
    "file": "common",
    "translations": {
      "loading": "Loading...",
      "saving": "Saving...",
      "error": {
        "title": "Something went wrong:",
        "button": "Try again"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "studio",
    "file": "homepage",
    "translations": {
      "title": "All apps",
      "app": {
        "create": "New App",
        "name": "App Name",
        "status": "Production Status",
        "updated": "Last updated",
        "empty": {
          "title": "No apps",
          "subtitle": "Your apps will be displayed here"
        }
      },
      "status": {
        "live": "Not Deployed",
        "outdated": "Outdated Version",
        "latest": "Latest Version",
        "default": "Default",
        "primary": "Primary",
        "indicator": "Version Indicator",
        "success": "Success",
        "error": "Error",
        "warning": "Warning"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "studio",
    "file": "manage",
    "translations": {
      "activity": "Recent Activity",
      "version": "Saved Version",
      "unpublished": "Unpublished"
    }
  },
  {
    "lang": "en",
    "namespace": "studio",
    "file": "navigation",
    "translations": {
      "main": {
        "manage": "Manage",
        "home": "Home",
        "build": "Build",
        "analytics": "Analytics"
      },
      "extra": {
        "preview": "Preview",
        "publish": "Publish Changes",
        "signout": "Logout"
      }
    }
  },
  {
    "lang": "en",
    "namespace": "studio",
    "file": "tag",
    "translations": {
      "latest": "latest",
      "outdated": "outdated",
      "live": "Live"
    }
  },
  {
    "lang": "hi",
    "namespace": "studio",
    "file": "build",
    "translations": {
      "addNewNode": "नया नोड जोड़ें",
      "simulatingGraphProgress": "ग्राफ़ सिमुलेशन प्रगति {{ progress }} है"
    }
  },
  {
    "lang": "hi",
    "namespace": "studio",
    "file": "common",
    "translations": {
      "loading": "लोड हो रहा है...",
      "saving": "सहेजा जा रहा है...",
      "error": {
        "title": "कुछ गलत हो गया:",
        "button": "पुनः प्रयास करें"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "studio",
    "file": "homepage",
    "translations": {
      "title": "सभी एप्लीकेशन",
      "app": {
        "create": "नया ऐप",
        "name": "एप्लिकेशन का नाम",
        "status": "उत्पादन स्थिति",
        "updated": "आखरी अपडेट"
      },
      "status": {
        "live": "तैनात नहीं किया गया",
        "outdated": "पुराना संस्करण",
        "latest": "नवीनतम संस्करण",
        "default": "चूक जाना",
        "primary": "प्राथमिक",
        "success": "सफलता",
        "error": "गलती",
        "warning": "चेतावनी"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "studio",
    "file": "manage",
    "translations": {
      "activity": "हाल की गतिविधि",
      "version": "सहेजा गया संस्करण",
      "unpublished": "अप्रकाशित"
    }
  },
  {
    "lang": "hi",
    "namespace": "studio",
    "file": "navigation",
    "translations": {
      "main": {
        "manage": "प्रबंधन",
        "home": "घर",
        "build": "कांग्रेस",
        "analytics": "विश्लेषकों"
      },
      "extra": {
        "preview": "निजी",
        "publish": "परिवर्तन प्रकाशित करें",
        "signout": "बाहर जाओ"
      }
    }
  },
  {
    "lang": "hi",
    "namespace": "studio",
    "file": "tag",
    "translations": {
      "latest": "अंतिम",
      "outdated": "रगड़ा हुआ",
      "live": "प्रासंगिक"
    }
  },
  {
    "lang": "ru",
    "namespace": "studio",
    "file": "build",
    "translations": {
      "addNewNode": "Добавить новый нод",
      "simulatingGraphProgress": "Прогресс моделирования графа составляет {{ progress }}"
    }
  },
  {
    "lang": "ru",
    "namespace": "studio",
    "file": "common",
    "translations": {
      "loading": "Загрузка...",
      "saving": "сохранение...",
      "error": {
        "title": "Что-то пошло не так:",
        "button": "Попробуйте еще раз"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "studio",
    "file": "homepage",
    "translations": {
      "title": "Все приложения",
      "app": {
        "create": "Новое приложение",
        "name": "Имя приложения",
        "status": "Состояние производства",
        "updated": "Последнее обновление"
      },
      "status": {
        "live": "Не развернуто",
        "outdated": "Устаревшая версия",
        "latest": "Последняя версия",
        "default": "По умолчанию",
        "primary": "Начальный",
        "success": "Успех",
        "error": "Ошибка",
        "warning": "Предупреждение"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "studio",
    "file": "manage",
    "translations": {
      "activity": "Недавняя деятельность",
      "version": "Сохраненная версия",
      "unpublished": "Неопубликованный"
    }
  },
  {
    "lang": "ru",
    "namespace": "studio",
    "file": "navigation",
    "translations": {
      "main": {
        "manage": "Управление",
        "home": "Домашняя",
        "build": "Констуктор",
        "analytics": "Аналитики"
      },
      "extra": {
        "preview": "Предпросмотр",
        "publish": "Опубликовать изменения",
        "signout": "Выйти"
      }
    }
  },
  {
    "lang": "ru",
    "namespace": "studio",
    "file": "tag",
    "translations": {
      "latest": "последний",
      "outdated": "устаревший",
      "live": "Актуально"
    }
  },
  {
    "lang": "zh",
    "namespace": "studio",
    "file": "build",
    "translations": {
      "addNewNode": "添加新节点",
      "simulatingGraphProgress": "图仿真进度为{{ progress }}"
    }
  },
  {
    "lang": "zh",
    "namespace": "studio",
    "file": "common",
    "translations": {
      "loading": "加載...",
      "saving": "节省...",
      "error": {
        "title": "出了些問題：",
        "button": "再試一次"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "studio",
    "file": "homepage",
    "translations": {
      "title": "所有應用程序",
      "app": {
        "create": "新應用",
        "name": "應用名稱",
        "status": "生產狀態",
        "updated": "最近更新時間"
      },
      "status": {
        "live": "未部署",
        "outdated": "過時的版本",
        "latest": "最新版本",
        "default": "默認",
        "primary": "基本的",
        "success": "成功",
        "error": "錯誤",
        "warning": "警告"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "studio",
    "file": "manage",
    "translations": {
      "activity": "近期活動",
      "version": "保存版本",
      "unpublished": "未出版"
    }
  },
  {
    "lang": "zh",
    "namespace": "studio",
    "file": "navigation",
    "translations": {
      "main": {
        "manage": "管理",
        "home": "家",
        "build": "國會",
        "analytics": "分析師"
      },
      "extra": {
        "preview": "個人的",
        "publish": "發布更改",
        "signout": "出去"
      }
    }
  },
  {
    "lang": "zh",
    "namespace": "studio",
    "file": "tag",
    "translations": {
      "latest": "最後的",
      "outdated": "過時",
      "live": "相關的"
    }
  }
];
